//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
// import _ from 'underscore'
import moment from 'moment'
// import DIC from '@/index/dictionary'
export default {
  props: {
    searchData: {
      default: {}
    }
  },
  data: function () {
    return {
      loading: true,
      chartWidth: '0px',
      orderCount: 0,
      chartSettings:  {
         area: true
      },
      chartData: {
        columns: ['时间', '销售总额', '成本总额'],
        rows: [
        ]
      },
      form: _.extend({
        type: 2
      }, this.searchData)
    }
  },
  watch: {
    'form.type': {
      handler (val) {
        if (val) {
          this.handleLoadData()
        }
      }
    },
    'form.beginTime': {
      handler (val) {
        if (val) {
          this.handleLoadData()
        }
      }
    }
  },
  components: {

  },
  mounted () {
    this.handleLoadData()
  },
  methods: {
    handleLoadData () {
      let data = _.pick(this.form, 'beginTime', 'type', 'endTime')
      this.loading = true
      let count = 0
      this.$axios.get('/mtea/store/admin/report/orderChart', { params: data }).then(res => {
        let rows = []
        this.chartData.rows = []
        _.each(res, (t, i, l) => {
          rows.push({
            '时间': t.time, '销售总额': Vue.filter('price')(t.orderAmount), '成本总额': Vue.filter('price')(t.pOrderAmount)
          })
          count += t.orderCount
          count += t.pOrderCount
        })
        this.chartData.rows = rows
        this.orderCount = count
      }).finally(() => {
        this.loading = false
        this.chartWidth = $('#reportOrderChart').width() + 'px'
      })
    }
  }
}
